import {
  Component,
  Input,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent {
  @Input() currentPage: number = 1;
  @Input() totalPages: number = 1;
  @Output() pageChange = new EventEmitter<number>();
  faAngleLeft = faAngleLeft;
  faAngleRight = faAngleRight;
  visiblePages: number = 5;

  constructor() {
    this.updateVisiblePages();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.updateVisiblePages();
  }

  updateVisiblePages() {
    if (window.innerWidth < 576) {
      this.visiblePages = 8;
    } else if (window.innerWidth < 768) {
      this.visiblePages = 10;
    } else {
      this.visiblePages = 10;
    }
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.pageChange.emit(page);
    }
  }

  getPages(): (number | string)[] {
    const pages: (number | string)[] = [];
    const range = this.visiblePages;

    if (this.totalPages <= range) {
      for (let i = 1; i <= this.totalPages; i++) {
        pages.push(i);
      }
    } else {
      const start = Math.max(1, this.currentPage - Math.floor(range / 2));
      const end = Math.min(this.totalPages, start + range - 1);

      if (start > 1) {
        pages.push(1, '...');
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (end < this.totalPages) {
        pages.push('...', this.totalPages);
      }
    }

    return pages;
  }
}
